import {PayMethod, SubscribePayMethodType} from '@web/core/constants'

/**
 * 디컨 정기
 * 2차 결제수단 리스트 결정
 */
export const getSecondPriorityPaymentMethodByDiconPolicy = (availablePayMethodMap: SubscribePayMethodType[]) => {
    const availablePayMethodList = [PayMethod.NONE, ...availablePayMethodMap]

    // 디컨 정기결제에서는 2차 결제수단으로 충전결제, 휴대폰 결제를 사용하지 못한다
    return availablePayMethodList.filter(
        (payMethod) => payMethod !== PayMethod.RECHARGE_POINT && payMethod !== PayMethod.MOBILE,
    )
}

/**
 * 방문예약
 * 2차 결제수단 리스트 결정
 */
export const getSecondPriorityPaymentMethodByBookingPolicy = (firstPayMethodTab: SubscribePayMethodType) => {
    const policyMap = {
        [PayMethod.RECHARGE_POINT]: [PayMethod.CARD_EASY_PAY],
        [PayMethod.CARD_EASY_PAY]: [PayMethod.NONE, PayMethod.RECHARGE_POINT, PayMethod.CARD_EASY_PAY],
        [PayMethod.BANK_EASY_PAY]: [],
        [PayMethod.MOBILE]: [],
        [PayMethod.NONE]: [],
    }

    // 매장방문결제는 1순위 결제수단에 따라 2순위 결제수단이 결정된다
    const availablePayMethodList = policyMap[firstPayMethodTab] || []

    return availablePayMethodList
}
